
// 左栏主界面组件
import left_main_list from "./left_main_list/left_main_list.vue";
// 左栏界面切换组件demo (示例用)
import left_cmpt_demo from "./left_cmpt_demo/left_cmpt_demo.vue";
// 2023年度“招拍挂”公开出让计划 切换组件
import left_crjh_list from "./left_crjh_list/left_crjh_list.vue";
// 自然资源局分局切换组件
import left_zrzyjfj_list from "./left_zrzyjfj_list/left_zrzyjfj_list.vue";
// 不动产受理点切换组件
import left_bdcsld_list from "./left_bdcsld_list/left_bdcsld_list.vue";

export default {
    name: 'zwfwmap_pc',


    /** 本页面用到的组件 */
    components: {
        left_main_list,// 左栏主界面组件
        left_cmpt_demo,// 左栏界面切换组件demo (示例用)
        left_crjh_list,// 2023年度“招拍挂”公开出让计划切换组件
        left_zrzyjfj_list,// 自然资源局分局切换组件
        left_bdcsld_list,// 不动产受理点切换组件
    },

    /** 本页面的属性 */
    data() {
        return {
            left_show_cmpt: 'main', //左栏组件状态位
            nowdate: "", //当前日期
            breadcrumb_2level_addr: {  //左栏面包屑当前二级地址
                left_crjh_list: '2023年度“招拍挂”公开出让计划',
                left_zrzyjfj_list: '自然资源局分局、县区局',
                left_bdcsld_list: '不动产受理点',
            },
        }
    },

    /** 计算属性 */
    computed: {},

    /** 构建页面时 */
    mounted() {
        console.log('run get date');
        this.formatDate();
    },

    /** 每次进入页面时 */
    activated() {

    },

    /** 每次退出页面时 */
    deactivated() {

    },
    provide() {
        return { setMessage: this.setMessage }
    },
    /** 本页面可用的方法 */
    methods: {
        //切换左栏组件方法
        change_left_cmpt(cmpt_name) {
            this.left_show_cmpt = cmpt_name;
        },

        //获取当前日期
        formatDate() {
            let date = new Date();
            let year = date.getFullYear(); // 年
            let month = date.getMonth() + 1; // 月
            let day = date.getDate(); // 日
            let week = date.getDay(); // 星期
            let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            // let hour = date.getHours(); // 时
            // hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
            // let minute = date.getMinutes(); // 分
            // minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
            // let second = date.getSeconds(); // 秒
            //second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
            this.nowdate = `${year}年${month}月${day}日 ${weekArr[week]}`;
            console.log('get date =' + this.nowdate);
        },

        setMessage(action, data) {
            var mapiframe = document.querySelector("iframe");
            console.log(action)
            console.log(data)
            console.log(mapiframe)
            mapiframe.contentWindow.postMessage({
                type: "map-emit",
                payload: {
                    action: action,
                    data: data,
                },
            },"*");
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/zwfwmap-pc/zwfwmap_pc.js